import React from 'react';
import { Observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import RoleForm from '../RoleForm';

const NewRole = () => {
  const history = useHistory();
  const { authStore } = useRootStore();
  const createOrgRole = async (roleName, rolePermissions) => {
    try {
      await authStore.request.post(`${process.env.REACT_APP_API}/api/roles`, {
        roleName,
        permissions: rolePermissions,
      });
      history.push('/roles');
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <Observer
      render={() => {
        return <RoleForm handleSubmission={createOrgRole} />;
      }}
    />
  );
};

export default NewRole;
